<div class="project-add-sent">
  <core-helpers-box-alert-message-icon
    [text]="message"
    [icon]="type"
  ></core-helpers-box-alert-message-icon>
    <fieldset class="sent">
      <core-helpers-forms-button-white
        [text]="firstButtonText"
        (submit)="onFirstAction()"
        [hidden]="firstButtonText == ''"
      ></core-helpers-forms-button-white>
      <core-helpers-forms-button-white
        [text]="secondButtonText"
        (submit)="onSecondAction()"
        [hidden]="secondButtonText == ''"
      ></core-helpers-forms-button-white>
    </fieldset>
</div>
